module.exports = __webpack_public_path__ + "cbf203f39574c0030b15c897bf1b2d71.svg";